import classNames from "classnames";
import { FunctionComponent, ReactElement } from "react";
import { PRO_PRICE } from "../../../../store/app/consts";
import styles from "./Pro.module.scss";
import { ReactComponent as ProSvg } from "./_assets/pro.svg";
import { IProProps } from "./types";

export const Pro: FunctionComponent<IProProps> = (
  props: IProProps
): ReactElement<IProProps> => {
  const { className, ...restProps } = props;

  return (
    <div
      className={classNames([
        "contentBox whiteBlockBg proBlock",
        styles.containerDefault,
        styles.bg,
        className,
      ])}
      {...restProps}
    >
      <ProSvg className={styles.iconDefault} />
      <h2 className="light">Получите больше возможностей</h2>
      <span className="proPrice" data-fancybox data-src="#pro">
        {`За ${PRO_PRICE.RUB} ₽ в месяц`}
      </span>
    </div>
  );
};
